<ng-container *ngIf="hasAccess; else landingPageHeaderTemplate">
  <header class="header-wrapper">
    <div class="header-wrapper-container">
      <div class="message-bar" *ngIf="isToastVisible">
        <app-toast
          [isToastVisible]="isToastVisible"
          [message]="deploymentBanner"
          class="toast topbanner"
          [toastType]="toastVariant"
          ariaLabel="{{ 'lbl_aria_msg_bar_close' | content }}"
          (closed)="onToastMessageBarClose()"
          [autoCloseEnabled]="false"
        />
      </div>
      <!--Sub Header-->
      <div class="sub-header-container">
        <form class="sub-menu-multiple-units" [formGroup]="subHeaderformGrp">
          <app-select
            [placeHolder]="selectedLocaleName"
            [controlName]="'locale'"
            className="header-locale-select header-account-select"
            [options]="localeList"
            [customTrigger]="viewingAsLocaleTrigger"
            [hideSingleSelectionIndicator]="false"
            [hasSearch]="true"
          ></app-select>
          <ng-template #viewingAsLocaleTrigger
            ><div
              class="sub-menu-account-label trigger sub-menu-select-trigger-label"
            >
              {{ selectedLocaleName }}
            </div></ng-template
          >

          <app-select
            [placeHolder]="
              ('header_viewing_as' | content) + ' - ' + selectedUnitName
            "
            [label]="'account_select_label' | content"
            [controlName]="'account'"
            className="header-account-select"
            [options]="unitsOptionsList"
            [hideSingleSelectionIndicator]="false"
            [customTrigger]="viewingAsTrigger"
            [hasSearch]="true"
            *ngIf="unitsList?.length && unitsList.length > 1"
          ></app-select>
          <ng-template #viewingAsTrigger
            ><div
              class="sub-menu-account-label trigger sub-menu-select-trigger-label"
            >
              {{ "header_viewing_as" | content }} - {{ selectedUnitName }}
            </div></ng-template
          >
        </form>
        <div
          class="sub-menu-single-unit"
          *ngIf="unitsList?.length && unitsList.length === 1"
        >
          <div class="sub-menu-account-label">
            {{ "header_viewing_as" | content }} - {{ selectedUnitName }}
          </div>
        </div>
      </div>
      <!--Header container-->
      <div
        class="header-container"
        [ngClass]="{ 'symphony-header-container': isSymphonyAccount }"
      >
        <div class="logo-section">
          @if (isSymphonyAccount) {
          <ng-container *ngTemplateOutlet="hamburgerMenu"></ng-container>
          }
          <button
            id="backControl"
            class="cm-icons cm-icons-arrow-left back-icon"
            (click)="handleBackClick()"
            *ngIf="headerConfig?.showBackBtn"
            [attr.data-automation]="'navigation_goback'"
            [attr.aria-label]="'header_back_button' | content"
          ></button>
          <a
            href="javascript:void(0)"
            class="logo-icon"
            [attr.aria-current]="isDashboardPage"
            [attr.aria-label]="'header_ups_logo_desc' | content"
            (click)="dashboardNavigation()"
          >
            <img
              [src]="headerConstants.upsLogo"
              [alt]="headerConstants.upsLogo_altText"
              class="ups-logo"
              data-automation="upsLogo"
            />
          </a>
          <div
            class="logo-text"
            [ngClass]="!headerConfig?.customText ? 'default-heading' : ''"
            data-automation="upsLogoText"
            *ngIf="!isMobile"
          >
            <ng-container *ngIf="!headerConfig?.customText">
              <span
                role="button"
                tabindex="0"
                (click)="redirectToDashboard()"
                (keydown.enter)="redirectToDashboard()"
                (keydown.space)="$event.preventDefault(); redirectToDashboard()"
              >
                {{ "header_title_ups_supply_chain" | content }}
              </span>
              <br />
              <span
                innerHtml="{{ 'header_title_digital_collab' | content }}"
              ></span>
            </ng-container>
            <ng-container *ngIf="headerConfig?.customText">
              <span
                class="navigate-to-account"
                (click)="navigateToAccountDetails()"
                (keyup)="navigateToAccountDetails()"
                tabindex="0"
              >
                {{ headerConfig.customText | decodevalue }}
              </span>
            </ng-container>
          </div>
        </div>
        @if (isSymphonyAccount) {
        <ng-container *ngTemplateOutlet="symphonyMainMenuNav"></ng-container>
        }
        <!-- Added sub nav -->
        <div class="sub-nav">
          <div class="icon-only">
            <a
              [attr.aria-label]="'lbl_notifications' | content"
              [attr.data-automation]="'notifications-icon'"
              href="javascript:void(0)"
              class="link-btn-icon"
              (click)="toggleNotifications()"
            >
              <i
                class="cm-icons cm-icons-bell-notification"
                aria-hidden="true"
              ></i>
              <div
                class="notification-count-wrapper"
                *ngIf="userNotificationsCount > 0"
              >
                <div class="notification-count">
                  {{ userNotificationsCount }}
                </div>
              </div>
            </a>
          </div>
          <div class="header-search-wrapper">
            <app-search-bar
              [placeholder]="'db_cases_search_placeholder' | content"
              [label]="'lbl_search_label' | content"
              [layout]="'Global Header'"
            />
          </div>

          <app-button
            [matMenuTrigger]="accountOptionsMenu"
            [text]="userFirstNameInitial"
            [getTextFromCMS]="false"
            variation="mini-fab"
            [ariaLabel]="'header_account_menu' | content"
            [className]="'account-icon'"
            automationAttribute="account-menu"
          />
          <mat-menu
            #accountOptionsMenu="matMenu"
            class="menu-options account-menu"
            xPosition="before"
          >
            <div class="menu-items-wrapper">
              <ng-container *ngFor="let item of menuItems">
                <span
                  *ngIf="!item.hide"
                  mat-menu-item
                  class="body4"
                  (click)="item.handler()"
                  (keydown.enter)="item.handler()"
                  [attr.data-automation]="'account-option-' + item.name"
                  tabindex="0"
                  role="menuitem"
                >
                  {{ "header_account_menu_" + item.name | content }}
                </span>
              </ng-container>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>
    <!--Message bar-->
    @if (isMessageToastVisible) {
    <div class="message-toast-section">
      <app-toast
        [isToastVisible]="isMessageToastVisible"
        [message]="toastMessage | content"
        class="toast"
        [toastType]="toastVariant"
        ariaLabel="{{ 'lbl_aria_msg_bar_close' | content }}"
        (closed)="handleDismissToast()"
      />
    </div>
    }
  </header>
</ng-container>

<!-- Symphony main nav menu -->
<ng-template #symphonyMainMenuNav>
  <div class="main-nav-menu">
    @if (isMenuItemsLoaded && symphonyMenuItems?.length) {
    <app-nav-menu
      [menuItems]="symphonyMenuItems"
      (unitAPIError)="setErrorToast()"
    ></app-nav-menu>
    } @if (!isMenuItemsLoaded && isDesktop) {
    <div class="loader nav-loader">
      <span class="sr-only"
        >{{ "lbl_loading" | content }} {{ "lbl_header_menu" | content }}</span
      >
    </div>
    }
  </div>
</ng-template>

<ng-template #landingPageHeaderTemplate>
  <header class="header-wrapper">
    <div class="header-wrapper-container">
      <div class="message-bar" *ngIf="isToastVisible">
        <app-toast
          [isToastVisible]="isToastVisible"
          [message]="deploymentBanner"
          class="toast"
          [toastType]="toastVariant"
          ariaLabel="{{ 'lbl_aria_msg_bar_close' | content }}"
          (closed)="onToastMessageBarClose()"
          [autoCloseEnabled]="false"
        />
      </div>
      <!--Sub Header-->
      <div class="sub-header-container">
        <form class="sub-menu-multiple-units" [formGroup]="subHeaderformGrp">
          <app-select
            [placeHolder]="selectedLocaleName"
            [controlName]="'locale'"
            className="header-locale-select header-account-select"
            [options]="localeList"
            [customTrigger]="landingLocaleSelectTrigger"
            [hideSingleSelectionIndicator]="false"
            [hasSearch]="true"
          ></app-select>
          <ng-template #landingLocaleSelectTrigger
            ><div
              class="sub-menu-account-label trigger sub-menu-select-trigger-label"
            >
              {{ selectedLocaleName }}
            </div></ng-template
          >
        </form>
      </div>
      <!-- Header container -->
      <div class="header-container ups-container">
        <div class="logo-section">
          <div class="logo-icon">
            <img
              [src]="headerConstants.upsLogo"
              [alt]="headerConstants.upsLogo_altText"
              class="ups-logo"
              data-automation="upsLogo"
            />
          </div>
          <div
            class="logo-text default-heading"
            data-automation="upsLogoText"
            *ngIf="!isMobile"
          >
            <ng-container>
              {{ "header_title_ups_supply_chain" | content }}
              <br />
              <span
                innerHtml="{{ 'header_title_digital_collab' | content }}"
              ></span>
            </ng-container>
          </div>
        </div>

        @if (!isRequestAccessPage) {
        <div class="sub-nav">
          <!-- auth0 login button -->
          @if (isLoginV2Flag) {
          <app-button
            text="lbl_auth0_login_btn"
            color="primary"
            className="cta-primary btn-in-header mr-2"
            class="d-inline-block"
            iconClassName="si si-angle-right"
            (clickEvent)="redirectToAuth0Login()"
            automationAttribute="Auth0LoginButton"
          />
          <app-button
            [hasIcon]="true"
            iconClassName="cm-icons-angle-right btn-icon-class"
            automationAttribute="UPSerLoginButton"
            [text]="'lbl_upser_login_btn' | content"
            variation="link"
            [getTextFromCMS]="true"
            className="cta-link link-text"
            (clickEvent)="redirectToUPSerLogin()"
            [ariaLabel]="'lbl_upser_login_btn' | content"
          >
          </app-button>
          } @else {
          <app-button
            text="lasso_login_btn"
            color="primary"
            (clickEvent)="redirectToLassoLogin()"
            automationAttribute="LassoLoginButton"
          />
          @if (isB2CEnabled) {
          <app-button
            text="azure_login_btn"
            color="secondary"
            (clickEvent)="redirectToB2CLogin()"
            automationAttribute="B2CLoginButton"
          />
          } }
        </div>
        } @if (isRequestAccessPage) {
        <div class="sub-nav">
          <app-button
            [matMenuTrigger]="requestAccessProfileMenu"
            [text]="userFirstNameInitial"
            [getTextFromCMS]="false"
            variation="mini-fab"
            [ariaLabel]="'header_account_menu' | content"
            [className]="'account-icon'"
            automationAttribute="request-access-account-menu"
          />
          <mat-menu
            #requestAccessProfileMenu="matMenu"
            class="menu-options account-menu"
            xPosition="before"
          >
            <div class="menu-items-wrapper">
              <span
                mat-menu-item
                class="body4"
                (click)="signOut()"
                (keydown.enter)="signOut()"
                [attr.data-automation]="'account-option-signOut'"
                tabindex="0"
                role="menuitem"
              >
                {{ "header_account_menu_signOut" | content }}
              </span>
            </div>
          </mat-menu>
        </div>
        }
      </div>
    </div>
  </header>
</ng-template>
<ng-template #templatePortalContent>
  <div class="overlay-notifications-wrapper" [appTrapFocus]="true">
    <div class="overlay-notifications-header">
      <div class="close-btn-wrapper">
        <button
          class="close-btn"
          [attr.aria-label]="'filters_close_panel_btn' | content"
          (click)="toggleNotifications(true)"
          [attr.data-automation]="'filters-panel-close-btn'"
        >
          <i class="cm-icons cm-icons-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="d-flex h4">
        <h4
          class="underline"
          data-automation="case-detail-heading"
          [attr.data-analytics-page-name]="'Edit User'"
        >
          {{ "lbl_notifications" | content }}
        </h4>
        <app-button
          text="lbl_dismiss_all"
          variation="link"
          automationAttribute="dismiss"
          (clickEvent)="markNotificationAsRead(userNotifications[0], 'ALL')"
        />
      </div>
    </div>
    <div
      class="overlay-notifications-body"
      [attr.data-automation]="'notifications-panel-body'"
    >
      <div
        *ngIf="isNotificationsLoading"
        class="loader"
        [style.height]="'70px'"
      ></div>
      <ng-container
        *ngIf="!userNotifications?.length && !isNotificationsLoading"
        >{{ "err_no_record_found" | content }}</ng-container
      >
      <ng-container
        *ngIf="userNotificationsOfToday?.length && !isNotificationsLoading"
      >
        <span class="notification-type">{{ "lbl_today" | content }}</span>
        <ng-container
          *ngFor="let notification of userNotificationsOfToday; index as i"
        >
          <div
            class="notification-card"
            role="button"
            tabindex="0"
            (click)="markNotificationAsRead(notification, 'BYCASE')"
            (keydown.enter)="markNotificationAsRead(notification, 'BYCASE')"
            (keydown.space)="
              $event.preventDefault();
              markNotificationAsRead(notification, 'BYCASE')
            "
          >
            <div class="notification-header">
              <div class="notification-time">
                {{ notification?.difference }}
              </div>
              <div
                class="notification-close"
                role="button"
                tabindex="0"
                (click)="
                  $event.stopPropagation();
                  markNotificationAsRead(notification, 'SINGLE')
                "
                (keydown.enter)="
                  $event.stopPropagation();
                  markNotificationAsRead(notification, 'SINGLE')
                "
                (keydown.space)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  markNotificationAsRead(notification, 'SINGLE')
                "
              >
                <span class="cm-icons cm-icons-close" aria-hidden="true"></span>
              </div>
            </div>
            <div class="notification-body">
              <span>{{ notification?.message }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container
        *ngIf="olderUserNotifications?.length && !isNotificationsLoading"
      >
        <span class="notification-type">{{ "lbl_older" | content }}</span>
        <ng-container
          *ngFor="let notification of olderUserNotifications; index as i"
        >
          <div
            class="notification-card"
            role="button"
            tabindex="0"
            (click)="markNotificationAsRead(notification, 'BYCASE')"
            (keydown.enter)="markNotificationAsRead(notification, 'BYCASE')"
            (keydown.space)="
              $event.preventDefault();
              markNotificationAsRead(notification, 'BYCASE')
            "
          >
            <div class="notification-header">
              <div class="notification-time">
                {{
                  $safeNavigationMigration(notification?.createdDate)
                    | date: "MM/dd/yyyy hh:mm a z"
                }}
              </div>
              <div
                class="notification-close"
                role="button"
                tabindex="0"
                (click)="
                  $event.stopPropagation();
                  markNotificationAsRead(notification, 'SINGLE')
                "
                (keydown.enter)="
                  $event.stopPropagation();
                  markNotificationAsRead(notification, 'SINGLE')
                "
                (keydown.space)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  markNotificationAsRead(notification, 'SINGLE')
                "
              >
                <span class="cm-icons cm-icons-close" aria-hidden="true"></span>
              </div>
            </div>
            <div class="notification-body">
              <span>{{ notification?.message }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #hamburgerMenu>
  @if (!isDesktop && isMenuItemsLoaded && symphonyMenuItems?.length) {
  <div class="hamburger-menu">
    @if (showHamburger) {
    <app-hamburger-menu
      id="hamburger-menu"
      (hamburgerClosed)="showOrHideHamburgerMenu(true)"
      [menuItems]="symphonyMenuItems"
      (unitAPIError)="setErrorToast()"
    ></app-hamburger-menu>
    }
    <app-button
      buttonId="hamburgerControl"
      (clickEvent)="showOrHideHamburgerMenu()"
      [hasIcon]="true"
      [iconClassName]="
        showHamburger ? 'cm-icons-close' : 'cm-icons-hamburger-menu'
      "
      automationAttribute="navigation_OpenHamburger"
      text=""
      variation="link"
      [getTextFromCMS]="false"
      className="menu-icon"
      [ariaLabel]="'lbl_header_menu' | content"
      [attr.aria-expanded]="showHamburger"
      [attr.aria-controls]="'hamburger-menu'"
    >
    </app-button>
  </div>
  }
</ng-template>
